// removed by extract-text-webpack-plugin
module.exports = {"container":"select-bank__container___3vImx","select":"select-bank__select___3gKr0"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/settings/salary-info/select-bank.scss
 ** module id = 1309
 ** module chunks = 1
 **/